module.exports = __webpack_public_path__ + "../resources/images/formatpainter-5c44e4b205a95150efd25f0d565146ea.svg";